export default __webpack_public_path__ + "static/media/ImgGift01.c93b3839.jpg";